const getCurrentTime = () => new Date().getTime();

export default getCurrentTime;
